import AppHeader from './AppHeader.vue';

export { AppHeader };
export default AppHeader;
